(function () {
  let isProcessing = false;

  function getChairHandles() {
    try {
      const el = document.getElementById('pillow-chair-handles');
      return el ? JSON.parse(el.textContent) : [];
    } catch(e) { return []; }
  }

  function getActiveAddons() {
    try {
      const el = document.getElementById('pillow-active-addons');
      return el ? JSON.parse(el.textContent) : [];
    } catch(e) { return []; }
  }

  const NECK = {
    handle: "ttracing-threadmark-pillow",
    zakekeUrl: "apps/zakeke?pid=7967964823614&handle=ttracing-threadmark-pillow&locale=en",
    image: "//ttracing.my/cdn/shop/files/1-threadmark-pillow-black_400x.png?v=1770361711",
    label: "Personalize neck pillow",
    price: "+RM 79",
    cls: "addon-line-neck"
  };

  const LUMBAR = {
    handle: "ttracing-threadmark-lumbar-pillow",
    zakekeUrl:
      "apps/zakeke?pid=8079445131326&handle=ttracing-threadmark-lumbar-pillow&locale=en",
    image:
      "//ttracing.my/cdn/shop/files/1-threadmark-lumbar-pillow-black_73dbac8c-6bb9-4549-90e5-f87da717c53f_400x.png?v=1778056793",
    label: "Personalize lumbar pillow",
    price: "+RM 99",
    cls: "addon-line-lumbar",
  };

  async function checkAddonLogic() {
    if (isProcessing) return;
    isProcessing = true;
    const cartEl = document.querySelector(".ast-cart");
    if (!cartEl) { isProcessing = false; return; }

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const chairHandles = getChairHandles();
      const chairItems  = cart.items.filter(item => chairHandles.includes(item.handle));
      const neckItems   = cart.items.filter(item => item.handle === NECK.handle);
      const lumbarItems = cart.items.filter(item => item.handle === LUMBAR.handle);

      // Stamp data-item-key and data-is-pillow-chair on every DOM item
      const allCartItemEls = document.querySelectorAll(".ast-cart__item");
      cart.items.forEach((item, index) => {
        const el = allCartItemEls[index];
        if (el) {
          el.dataset.itemKey = item.key;
          el.dataset.isPillowChair = chairHandles.includes(item.handle) ? 'true' : 'false';
        }
      });

      chairItems.forEach(chair => {
        const chairDOM = document.querySelector(`.ast-cart__item[data-item-key="${chair.key}"]`);
        if (!chairDOM) return;

        const activeAddons = getActiveAddons();
        const neckLinked   = !activeAddons.includes(NECK.handle)   || neckItems.filter(p   => Number(p.properties._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;
        const lumbarLinked = !activeAddons.includes(LUMBAR.handle) || lumbarItems.filter(p => Number(p.properties._linked_chair_variant_id) === chair.variant_id).length >= chair.quantity;

        renderAddonLines(chairDOM, chair.variant_id, neckLinked, lumbarLinked);
      });

      addZakekeEditButtons(cart);

    } catch (err) {
      console.error("Addon check failed", err);
    } finally {
      isProcessing = false;
      const cartEl = document.querySelector(".ast-cart");
      if (cartEl && cartEl.classList.contains("cart-updating")) {
        cartEl.classList.remove("cart-updating");
      }
    }
  }

  function renderAddonLines(chairDOM, chairKey, neckLinked, lumbarLinked) {
    // Clear and re-render both addon rows so order is always consistent
    chairDOM.querySelectorAll(".addon-line-neck, .addon-line-lumbar").forEach(el => el.remove());

    const priceRow = chairDOM.querySelector(".ast-cart__item__price-row");
    if (!priceRow) return;

    let insertAfter = priceRow;

    if (!neckLinked) {
      const div = buildAddonDiv(NECK, chairKey);
      insertAfter.insertAdjacentElement("afterend", div);
      insertAfter = div;
    }

    if (!lumbarLinked) {
      const div = buildAddonDiv(LUMBAR, chairKey);
      insertAfter.insertAdjacentElement("afterend", div);
    }
  }

  function buildAddonDiv(addon, chairKey) {
    const div = document.createElement("div");
    div.className = "addon-line-custom " + addon.cls;
    div.innerHTML = `
      <div class="pillow-img"><img src="${addon.image}"></div>
      <div class="addon-line-inner" style="display:flex; justify-content:space-between; font-size:14px; align-items:center; flex: 1;">
        <span>${addon.label} <span>${addon.price}</span></span>
        <a href="/${addon.zakekeUrl}&linked_chair=${chairKey}">Add On</a>
      </div>
    `;
    return div;
  }


  function setDisabled(btn, disabled) {
    btn.disabled = disabled;
    btn.style.opacity = disabled ? "0.5" : "";
    btn.style.cursor = disabled ? "not-allowed" : "";
    if (disabled) btn.setAttribute("aria-disabled", "true");
    else btn.removeAttribute("aria-disabled");
  }

  function addZakekeEditButtons(cart) {
    cart.items.forEach((item) => {
      const cartItemEl = document.querySelector(`.ast-cart__item[data-item-key="${item.key}"]`);
      if (!cartItemEl) return;

      const existingBtn = cartItemEl.querySelector(".zakeke-edit-btn");

      if (item.properties?._customization && item.properties._customization !== 0) {
        if (existingBtn) return;

        const removeBtn = cartItemEl.querySelector(".ast-cart__item__remove");
        if (!removeBtn) return;

        const editBtn = document.createElement("a");
        editBtn.href = `/apps/zakeke?pid=${item.product_id}&design=${item.properties._customization}&quantity=${item.quantity}&linked_chair=${item.properties._linked_chair_variant_id}`;
        editBtn.className = "ast-button ast-button--sm ast-button--plain ast-button--color-neutral ast-button--radius-md ast-button--icon-only zakeke-edit-btn";
        editBtn.setAttribute("aria-label", "Edit customization");
        editBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>`;

        removeBtn.insertAdjacentElement("beforebegin", editBtn);
      } else {
        if (existingBtn) existingBtn.remove();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    checkAddonLogic();
    bindChairQuantityListeners();
    watchAstraCartOpen();
  });

  document.addEventListener("cart:updated", () => {
    checkAddonLogic();
  });

  function watchAstraCartOpen() {
    function observe() {
      const astCart = document.querySelector(".ast-cart");
      if (!astCart) {
        setTimeout(observe, 500);
        return;
      }
      new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
          if (mutation.attributeName === "class" && astCart.classList.contains("ast-open")) {
            setTimeout(checkAddonLogic, 300);
            break;
          }
        }
      }).observe(astCart, { attributes: true, attributeFilter: ["class"] });
    }
    observe();
  }

  function bindChairQuantityListeners() {
    function isTargetChairItem(el) {
      const itemEl = el.closest(".ast-cart__item");
      return itemEl && itemEl.dataset.isPillowChair === 'true';
    }

    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".ast-quantity__plus, .ast-quantity__minus");
      if (!btn || !isTargetChairItem(btn)) return;
      const cartEl = document.querySelector(".ast-cart");
      if (cartEl) cartEl.classList.add("cart-updating");
    }, true);

    document.addEventListener("change", (e) => {
      const input = e.target.closest(".ast-quantity input");
      if (!input || !isTargetChairItem(input)) return;
      const cartEl = document.querySelector(".ast-cart");
      if (cartEl) cartEl.classList.add("cart-updating");
    });
  }

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (
      typeof url === "string" &&
      (
        url.includes("/cart/add") ||
        url.includes("/cart/change")
      )
    ) {
      setTimeout(() => {
        checkAddonLogic();
      }, 150);
    }

    return response;
  };

})();
